<template>
    <div class="chat-area" :class="{active: inputActive}">
        <input type="file" @change="upload($event)" id="uploadfile">
        <div class="iscroll content_Odiv text"
             :contenteditable="!currIsBlack"
             @blur="endInput"
             @focus="startInput"
             @input="editInput"
             @paste="pasting"
             @keydown.enter.prevent.exact="send"
             @keydown.enter.ctrl.prevent="createBr"
             v-if="currentConfig" ref="contentEdit"
             aria-label="Rich Text Editor, main"
             id="hzEditorContentEditable"
             :placeholder="multyLang&&multyLang[(currentConfig.placeHolder).trimlr()]?multyLang[(currentConfig.placeHolder.trimlr())][currentTranslateCode]:''"></div>
        <div class="other-edit">
            <button @click="insertEmoji"><i class="edit-icon hz-icon-weixiao icon-weixiao"
                                            :class="currIsBlack?'disable-icon':''"></i></button>
            <span class="edit-icon el-icon-folder-opened" :class="currIsBlack?'disable-icon':''" @click="uploadfile"
                  v-show='!editValue'></span>
            <span class="edit-icon hz-icon-zan2" :class="currIsBlack?'disable-icon':''" @click="sendZan"
                  v-show='!editValue'></span>
            <span class="hz-icon-icon_sent icon-icon_sent" :class="currIsBlack?'disable-icon':''" @click="sendMsg"
                  v-show="editValue"></span>
        </div>
        <div class="emoji_box iscroll" id="emoji_box" v-show="showEmoji">
            <emotion @handleEmotion="handleEmotion" :showEmoji = showEmoji></emotion>
        </div>


        <div class="show_cutImg" v-if="sendScreenshot">
            <div class="show_cutImg_box">
                <div class="show_img">
                    <img :src="screenshotImgUrl" alt="">
                </div>


                <div class="show_cut_btnbox">
                    <hz-button size="mini" @click="cancleSend" type="default">{{multyLang&&multyLang["取消"]?multyLang["取消"][currentTranslateCode]:'Cancel'}}</hz-button>
                    <hz-button size="mini" @click="InsureSend" type="primary">{{multyLang&&multyLang["确定"]?multyLang["取消"][currentTranslateCode]:'Confirm'}}</hz-button>
                </div>
            </div>


        </div>

    </div>
</template>

<script>
    import {faceUrl} from "@/config/env";
    import emotion from './Emotion'
    import emojiList from '../util/emoji'
    import {store, mutations} from "../store";
    import HzButton from "./button";

    export default {
        name: "chatArea",
        data() {
            return {
                showEmoji: false,
                inputActive: false,
                editValue: "",
                screenshotImgUrl:'',
                sendScreenshot:false,
                hasContactNim:false,
            }
        },
        props: {
            nim: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            currentConfig: {
                type: Object,
                default() {
                    return {}
                }
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            currIsBlack() {
                return store.currIsBlack;
            },
            multyLang() {
                return store.multyLang
            },
            currentTranslateCode() {
                return store.currentTranslateCode
            }
        },
        components: {
            HzButton,
            emotion
        },
        mounted() {
            this.initEvents();
            let ele = document.getElementById("hzEditorContentEditable");
            // this.addPasteEvent(ele)
        },
        watch: {
            disabled() {
                if (this.disabled) {
                    this.$refs.contentEdit.blur();
                }
            }
        },
        methods: {
            isIE() {
                if (!!window.ActiveXObject || 'ActiveXObject' in window) {
                    return true;
                } else {
                    return false;
                }
            },
            initEvents() {
                let vm = this;
                document.addEventListener('click', function (e) {
                    let ele = e.target;
                    if (e.target.className.indexOf('icon-weixiao') >= 0) {
                        return
                    }
                    let emoji_box = document.getElementById('emoji_box');
                    if (!emoji_box.contains(ele)) {
                        vm.showEmoji = false;
                    }
                }, false)
            },
            handleEmotion(index) {
                let _index = emojiList.indexOf(index);
                let src = `${faceUrl}${_index}.png`;
                document.execCommand("insertImage", false, src);
            },
            editInput() {
                this.editValue = this.$refs.contentEdit.innerHTML;
            },
            sendMsg() {
                if (this.disabled) {
                    return
                }
                if (this.currIsBlack) {
                    return
                } else {
                    this.send();
                }
            },
            send() {
                let content = this.getContent();
                let vm = this;
                if (/<img .*?src="(.*?)".*?\/?>/.test(content)) {
                    let imglist = content.match(/<img .*?src="(.*?)".*?\/?>/g);
                    imglist.forEach(index => {
                        let num = vm.getImgName(index);
                        content = content.replace(index, `${emojiList[num]}`)
                    })
                }
                content = content.replace(/<(?!\/?br>)[^<>]*>/g, '');
                if (content.replace(/<.*?>/g, "").replace(/&nbsp;/g, '') == '') {
                    try {
                        this.$message(vm.multyLang['请不要发送空消息'][vm.currentTranslateCode])
                    } catch (e) {
                        this.$message('Please do not send empty messages')
                    }

                    return
                }
                if (/^\s*$/.test(content)) {
                    try {
                        this.$message(vm.multyLang['请不要发送空消息'][vm.currentTranslateCode])
                    } catch (e) {
                        this.$message('Please do not send empty messages')
                    }
                    return
                } else if (content.length > 800) {
                    try {
                        this.$message(vm.multyLang['文本过长'][vm.currentTranslateCode])
                    } catch (e) {
                        this.$message("The text is too long")
                    }

                    return
                }
                if (!this.currIsBlack) {
                    mutations.sendText(content)
                }
            },


          connectNim(){
              if(!this.hasContactNim){
                mutations.connectNim();
              }
              this.hasContactNim = true;
          },

            getImgName(url) {
                let num1 = url.lastIndexOf('/');
                let num2 = url.lastIndexOf('.');
                return url.substring(num1 + 1, num2);
            },
            insertEmoji() {
                this.focuson();
                this.showEmojiModal();
            },
            uploadfile() {
                document.querySelector('#uploadfile').click();
            },
            createBr() {
                document.execCommand('insertHTML', false, '</br></br>');
            },
            showEmojiModal() {
                this.showEmoji = true;
            },
            upload(e) {
                let target = e.target;
                if (!this.currIsBlack) {
                    mutations.sendFile(target)
                }

            },
            getContent() {
                let contentEdit = this.$refs.contentEdit;
                let html = contentEdit.innerHTML;
                contentEdit.innerHTML = '';
                this.editValue = ''
                return html;
            },
            focuson() {
                let contentEdit = this.$refs.contentEdit;
                if (contentEdit.innerHTML == '') {
                    contentEdit.focus();
                }
            },
            sendZan() {
                if (!this.currIsBlack) {
                    mutations.sendCustomMsg({
                        type:'custom',
                        txt:'&#xe71b;'
                    })
                }

            },
            startInput() {
                console.info("开始输入")
                mutations.sendSysCustemMsg(true);
                this.$emit('sendMsgReceipt');
                this.inputActive = true;
                console.info("开始连接nim")
                this.connectNim();
            },
            endInput() {
                console.info("结束输入")
                mutations.sendSysCustemMsg(false);
                this.inputActive = false
            },
            /*获取到截图*/
            pasting(e) {
                let _this = this;
                e.preventDefault()



                if (e.clipboardData.files[0]) {//获取剪切板图片
                    if(!store.showChatModel)return
                    let oFile = e.clipboardData.files[0];
                    var oFReader = new FileReader();
                    oFReader.readAsDataURL(oFile); // 开始在后台进行读取操作。当图像文件的所有内容加载后,他们转换成一个data:URL,传递到onload回调函数中
                    oFReader.onload = function (oFREvent) { //当读取操作成功完成时调用.
                        _this.screenshotImgUrl = oFREvent.target.result;
                        _this.sendScreenshot = true;
                    };
                }

                let txt = ''
                let range = null
                // 获取复制的文本
                txt = e.clipboardData.getData('text/plain')
                // 获取页面文本选区
                range = window.getSelection().getRangeAt(0)
                // 删除默认选中文本
                range.deleteContents()
                // 创建一个文本节点，用于替换选区文本
                let textTag = document.createElement("span");
                textTag.innerHTML = txt.replace(/(\r\n|\n|\r)/g, '<br>');
                // let pasteTxt = document.createTextNode()
                // 插入文本节点
                range.insertNode(textTag)
                // 将焦点移动到复制文本结尾
                range.collapse(false);
            },
            cancleSend() {
                this.sendScreenshot = false;
                this.screenshotImgUrl = '';
            },

            /*上传截图*/
            InsureSend() {
                let _this = this;
                mutations.sendScreenshotFile( _this.screenshotImgUrl)
                _this.sendScreenshot = false;
            },
        }
    }
</script>

<style lang="scss">
    #hz_chat_app {
        z-index: 999999;
        .chat-area {
            width: 100%;
            transition: background-color 0.2s ease, box-shadow 0.2s ease;
            height: 100%;
            position: relative;
            background: #fff;
            pointer-events: auto;
            .content_Odiv {
                padding: 18px;
                min-height: 56px;
                max-height: 125px;
                transition: all 0.28s;
                outline: none;
                width: 100%;
                text-align: center;
                /*padding: 10px;*/
                text-align: left;
                overflow-y: auto;
                float: left;
                padding: 14px;
                line-height: 24px;
                padding-right: 105px;
                img {
                    margin-right: 2px;
                    height: 24px;
                    width: auto;
                    display: inline-block;
                    vertical-align: bottom;
                }
            }

            &.chat-area.active {
                box-shadow: none;
                background-color: white;
                box-shadow: 0px -5px 20px 0px rgba(150, 165, 190, 0.2);
            }

            .uploadicon {
                margin-left: 5px;
                margin-right: 5px;
            }

            .text:empty:before {
                font-size: 14px;
                content: attr(placeholder);
                color: #bbb;
            }

            div[contenteditable="true"] {

            }

            div[contenteditable=true] img {

            }

            .text:focus {
                content: none;
            }

            input[type='file'] {
                display: none;
            }

            .emoji_box {
                position: absolute;
                height: 120px;
                width: 280px;
                border: 1px solid #F1F0F0;
                z-index: 9999;
                margin-top: -115px;
                right: 27px;
                background: #fff;
                overflow-y: auto;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
            }

            .emoji_box:after {
              /*  position: absolute;
                left: 200px;
                bottom: -8px;
                content: '';
                width: 0;
                height: 0;
                border: 8px solid red;
                border-left-color: transparent;
                border-bottom: none;
                border-right-color: transparent;
                border-top-color: #F1F0F0;*/
            }

            .other-edit {
                height: 56px;
                line-height: 56px;
                position: absolute;
                right: 0;
                bottom: 0;
                top: 0;
                width: 105px;

            }

            .other-edit .el-icon-folder-opened {
                /*margin:0 18px;*/
            }

            .other-edit button {
                margin: 0;
                padding: 0;
                border: 1px solid transparent;
                background: none!important;
                outline: none;
                display: inline;
                width: auto;
                height:auto ;
            }

            .edit-icon {
                color: #90959E;
                margin-right: 16px;
                cursor: pointer;
                font-size: 18px;

            }
            button.edit-icon {
                line-height: 50px;
            }
            span.edit-icon {
                line-height: 50px;
            }
            .icon-icon_sent {
                color: #428BCA;
                cursor: pointer;
            }
            .disable-icon {
                opacity: 0.6;
                cursor: not-allowed;
            }
        }
    }

    .show_cutImg{
        position: fixed;
        top:0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background:rgba(50,50,50,0.6);
        z-index: 999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .show_cutImg_box{
        width: 90%;
        height: 50%;
        background: #ffffff;
    }
    .show_img{
        padding: 10px;
        width: 100%;
        height: calc(100% - 50px);
    }
    .show_img img{
        max-width: 100%;
        height: auto;
        display: block;
        margin: 0 auto;
        max-height: 70%;
        width: auto;
    }
    .show_cut_btnbox{
        height: 50px;
    }
    .show_cut_btnbox button{
        margin: 10px!important;
    }
</style>
